import BarChart from './BarChart'
import LineChart from './LineChart'
import DoughnutChart from './DoughnutChart'
import TankChart from './TankChart.vue'

export {
  BarChart,
  LineChart,
  DoughnutChart,
  TankChart
}
